import { render, staticRenderFns } from "./popup-content.vue?vue&type=template&id=cafc64be&scoped=true&"
import script from "./popup-content.vue?vue&type=script&lang=js&"
export * from "./popup-content.vue?vue&type=script&lang=js&"
import style0 from "./popup-content.vue?vue&type=style&index=0&id=cafc64be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cafc64be",
  null
  
)

export default component.exports